import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import appStoreBadge from "../../Assets/app-store.svg";
import playStoreBadge from "../../Assets/play-store.svg";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        {props.ghLink && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>
        )}
        {"\n"}
        {"\n"}

        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Link"}
          </Button>
        )}

        {/* Download App section - App Store and Google Play */}
        {(props.appStoreLink || props.playStoreLink) && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
              marginTop: "20px",
              flexWrap: "wrap",
            }}
          >
            {props.appStoreLink && (
              <a
                href={props.appStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={appStoreBadge}
                  alt="Download on the App Store"
                  style={{
                    height: "40px",
                  }}
                />
              </a>
            )}
            {props.playStoreLink && (
              <a
                href={props.playStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={playStoreBadge}
                  alt="Get it on Google Play"
                  style={{
                    height: "40px",
                  }}
                />
              </a>
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
